import { useDispatch } from 'react-redux';
import * as $ from 'jquery';
import Alert from '../../../itrust_common/components/Alert';
import { examEdit } from '../../../redux/actions/exam/examActions';
import { onBoardingTourInfoUpdate } from '../../../redux/actions/onBoardingActions';
import { quickActionsReset } from '../../../redux/actions/dashboard/quickActionActions';
import { patientReset } from '../../../redux/actions/patient/patientActions';
import { storeStaffsLoad } from '../../../redux/actions/currentStoreActions';

export default function CreateExamButton(props) {
  const { patientId, defaultProcedureIds, appointmentId, staffId, children, isQuickAction, activeTourType } = props;
  const dispatch = useDispatch()

  const handleExamEdit = (id, data) => {
    let localStorageStoreId = localStorage.getItem('StoreID')
    if (localStorageStoreId && localStorageStoreId !== 'null') {
      dispatch(storeStaffsLoad(localStorageStoreId, { rpp: 1000, filter: { doctor: localStorageStoreId } }))
    }
    if (localStorageStoreId == null) {
      Alert.warning("Please select store from top dropdown.")
    } else {
      isQuickAction && handleQuickActionClose()
      dispatch(examEdit(id, data));
      setTimeout(() => {
        $('#newExamForm-modal').modal('show');
        if (activeTourType === 'create_exam') {
          dispatch(onBoardingTourInfoUpdate({ stepIndex: 1, isTourActive: true, activeTourType: 'create_exam' }))
        }
      }, 1000)
    }
  }

  const handleQuickActionClose = () => {
    $('#patientSelect-modal').modal('hide');
    if (isQuickAction) {
      dispatch(quickActionsReset())
    }
    else {
      dispatch(patientReset())
    }
  }

  return (
    <span
      className="pointer"
      onClick={() => handleExamEdit('New', { patientId, appointmentId, defaultProcedureIds, staffId })}
    >
      {children}
    </span>
  )
}
